<template>
    <div id="app">
        <div :class="getAlerts.length > 0 && 'space-y-1 sm:py-3'" class="fixed top-0 w-full" style="z-index: 999;">
            <AlertComponent v-for="(alert, index) in getAlerts" :key="index" :alert="alert"/>
        </div>
        <router-view />
        <FooterComponent />
        <ModalImage v-if="getShowModalImage" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FooterComponent from './components/FooterComponent'
import AlertComponent from './components/helper/AlertComponent.vue'
import ModalImage from '@/components/ModalImageComponent.vue';

export default {
    components: {
        FooterComponent,
        AlertComponent,
        ModalImage
    },
    watch: {
        '$store.state.helpers.hideScrollBar': function () {
            if (this.$store.state.helpers.isMenuOpen) {
                document.documentElement.style.overflow = 'hidden'
            } else {
                document.documentElement.style.overflow = null
            }
        }
    },
    computed: {
        ...mapGetters(['getAlerts', 'getShowModalImage']),
    }
}
</script>

<style lang="scss">
html {
    font-family:
        Roboto,
        'Source Sans Pro',
        -apple-system,
        BlinkMacSystemFont,
        'Segoe UI',
        'Helvetica Neue',
        Arial,
        sans-serif;
    font-size: 16px;
    word-spacing: 1px;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    box-sizing: border-box;
    background-color: white;
}

*,
*::before,
*::after {
    box-sizing: border-box;
    margin: 0;
}

.__alert {
    backdrop-filter: blur(10px);
    background-color: rgba(0, 195, 255, 0.041);
}

button {
    cursor: pointer;
}

ul {
    list-style: none;
    padding-left: 0px;
}
</style>